var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: "" } },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    disabled: _vm.selectedInvoices.length == 0
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleExtendTheLot()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("InvoiceDisputesDialog.Extend")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    disabled: _vm.selectedInvoices.length == 0
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleCancelTheLot()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("InvoiceDisputesTable.complete")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    value: _vm.$t("invoice-disputes.assign_to"),
                    placeholder: _vm.$t("invoice-disputes.assigned_to"),
                    disabled: _vm.selectedInvoices.length == 0
                  },
                  on: { change: _vm.handleAssignTheLot }
                },
                [
                  _c("el-option", {
                    key: "unassigned",
                    attrs: {
                      label: _vm.$t("invoice-disputes.unassigned"),
                      value: "unassigned"
                    }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.$store.state.risolto.participantUsers, function(
                    user
                  ) {
                    return _c("el-option", {
                      key: user.person_by_reference.reference,
                      attrs: {
                        label: user.person_by_reference.username,
                        value: user.person_by_reference.reference
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.invoiceDisputes },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "45" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "192",
              prop: "invoice",
              label: _vm.$t("InvoiceDisputesTable.invoice")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "hover-underline blueColor",
                            attrs: {
                              to: {
                                name: "invoice-detail",
                                params: {
                                  reference: scope.row.invoice.reference
                                }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(scope.row.invoice.invoice_number) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "250",
              label: _vm.$t("InvoiceDisputesTable.dispute_code")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate.dispute_code(
                              scope.row.dispute_code_by_reference.code
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      scope.row.tasks[0].notes.length > 0
                        ? _c("div", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(scope.row.tasks[0].notes[0].note) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "total_amount",
              label: _vm.$t("amount"),
              "show-overflow-tooltip": "",
              align: "right",
              width: "96"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.$formatter.toCurrency(
                          scope.row.invoice.total_amount,
                          scope.row.invoice.amount_currency
                        )
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "open_amount",
              label: _vm.$t("open"),
              "show-overflow-tooltip": "",
              align: "right",
              width: "96"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.$formatter.toCurrency(
                          scope.row.invoice.open_amount,
                          scope.row.invoice.amount_currency
                        )
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "128",
              label: _vm.$t("InvoiceDisputesTable.due_date")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "until" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseTime")(scope.row.until, "{d}-{m}-{y}")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isDue(scope.row)
                        ? _c("span", [_vm._v("•")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isOverdue(scope.row)
                        ? _c("span", [_vm._v("•")])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("InvoiceDisputesTable.assignee"),
              width: "144"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "mini",
                          value: scope.row.tasks[0].assignee,
                          placeholder: _vm.$t("invoice-disputes.assigned_to")
                        },
                        on: {
                          change: function($event) {
                            return _vm.handleAssignInvoiceDispute(
                              scope.row,
                              $event
                            )
                          }
                        }
                      },
                      [
                        _c("el-option", {
                          key: "unassigned",
                          attrs: {
                            label: _vm.$t("invoice-disputes.unassigned"),
                            value: "unassigned"
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.$store.state.risolto.participantUsers,
                          function(user) {
                            return _c("el-option", {
                              key: user.person_by_reference.reference,
                              attrs: {
                                label: user.person_by_reference.username,
                                value: user.person_by_reference.reference
                              }
                            })
                          }
                        )
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("InvoiceDisputesTable.attachments"),
              width: "156"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "attachments" },
                      [
                        _vm._l(scope.row.invoice.attachments, function(
                          attachment,
                          index
                        ) {
                          return _c(
                            "el-tooltip",
                            {
                              key: index,
                              attrs: {
                                content: attachment.name,
                                placement: "top",
                                effect: "dark"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  key: index,
                                  style: {
                                    width: "148px",
                                    overflow: "hidden",
                                    "white-space": "nowrap",
                                    "text-overflow": "ellipsis"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleAttachments(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(attachment.name) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.handleAttachments(
                                  scope.$index,
                                  scope.row
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t+ " +
                                _vm._s(
                                  _vm.$t("invoice-disputes.no_attachments")
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.userInterfaceDetails &&
          _vm.userInterfaceDetails.custom_field_definitions &&
          _vm.userInterfaceDetails.custom_field_definitions.length > 0
            ? _vm._l(
                _vm.userInterfaceDetails.custom_field_definitions.slice(0, 3),
                function(custom_field_definition) {
                  return _c(
                    "el-table-column",
                    {
                      key: custom_field_definition.path,
                      attrs: { width: "160", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("custom-field-value", {
                                  attrs: {
                                    "custom-field-definition": custom_field_definition,
                                    "custom-fields":
                                      scope.row.invoice.custom_fields
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("custom-field-label", {
                            attrs: {
                              "custom-field-definition": custom_field_definition
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                }
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("paymentReferenceShort"),
              prop: "payment_reference",
              "show-overflow-tooltip": "",
              width: "192"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.invoice.payment_reference))]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("dispute-dialog", {
        attrs: {
          visible: _vm.disputeDialogVisible,
          participant: _vm.$store.state.risolto.selectedParticipantStore,
          "legal-entity": _vm.legalEntity,
          recipient: _vm.recipient,
          "invoice-dispute": _vm.selectedInvoicesDispute,
          invoices: _vm.selectedInvoices
        },
        on: {
          "dialog-close": _vm.handleDialogClose,
          confirm: _vm.handleExtendConfirm
        }
      }),
      _vm._v(" "),
      _c("cancel-dispute-dialog", {
        attrs: {
          visible: _vm.cancelDisputeDialogVisible,
          participant: _vm.$store.state.risolto.selectedParticipantStore,
          "legal-entity": _vm.legalEntity,
          invoices: _vm.selectedInvoices
        },
        on: {
          "dialog-close": _vm.handleCancelDialogClose,
          confirm: _vm.handleCancelConfirm
        }
      }),
      _vm._v(" "),
      _c("attachments-dialog", {
        attrs: {
          participant: _vm.$store.state.risolto.selectedParticipantStore,
          "legal-entity": _vm.legalEntity,
          visible: _vm.attachmentsDialogVisible,
          "file-list": _vm.attachmentsDialogFileList.value || [],
          "on-upload": _vm.handleAttachmentUpload,
          "on-remove": _vm.handleAttachmentRemove
        },
        on: {
          "dialog-close": function($event) {
            _vm.attachmentsDialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }